import React from 'react';

import { FunctionField, ShowButton, List, Datagrid, TextField, EditButton, TextInput, Filter } from 'react-admin';

import CommandEmpty from './empty';

import StringUtil from '../../utils/string';

const CommandFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Name" source="name" allowEmpty />
    <TextInput label="SQL Query" source="sql" allowEmpty />
    <TextInput label="Created by" source="createdBy" allowEmpty />
  </Filter>
);

const CommandList = (props) => {
  const getAuthor = (record) => {
    let author = '';
    if (record) {
      author = record.updatedBy ? record.updatedBy : record.createdBy;
    }

    return StringUtil.titleCase(author);
  }

  return (
    <List
      title='Commands'
      empty={<CommandEmpty />}
      filters={<CommandFilter />}
      bulkActionButtons={false}
      sort={{ field: 'name', order: 'ASC' }}
      {...props}
    >
      <Datagrid>
        <TextField source="name" label="Name" />
        <TextField source="sql" label="SQL Query" />
        <FunctionField label="Updated By" render={record => getAuthor(record)} />
        <ShowButton />
        <EditButton />
      </Datagrid>
    </List>
  );
};

export default CommandList;
